export default __webpack_public_path__ + "static/media/gc_logo_orange.8c3f09e7.png";